import React from "react";
import { ReactComponent as CartIcon } from "./cart-shopping.svg";
import { ReactComponent as ChevronIcon } from "./chevron-right.svg";
import "./ActionButton.scss";
import { useSelector } from "react-redux";

const ActionButton = ({ hit }) => {
    const { BUTTON_TEXT_CONFIG, BUTTON_TEXT_ADD } = useSelector(
        (state) => state.config,
    );
    const pconflag = hit.detail_pconflag;

    const hitURL = hit.url.includes("?")
        ? hit.url + "&queryID=" + hit.__queryID
        : hit.url + "?queryID=" + hit.__queryID;

    const handleButtonClick = () => {
        if (pconflag) {
            window.location.href = hitURL + "#pconIframe";
        } else {
            window.location.href = hitURL;
        }
    };

    return (
        <div className="search-hit__action">
            <div
                className="search-hit__action-button"
                onClick={handleButtonClick}
            >
                {pconflag ? BUTTON_TEXT_CONFIG : BUTTON_TEXT_ADD}
                {pconflag ? <ChevronIcon /> : <CartIcon />}
            </div>
        </div>
    );
};

export default ActionButton;
